import {
  AppBar,
  Box,
  Button,
  ButtonGroup,
  Container,
  Fade,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import React, { FC, ReactNode, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import { IS_AUTHENTICATED, SET_TOKEN } from "slices/global.slice";
import classes from "./style";
import Footer from "./footer";

interface LayoutProps {
  children: ReactNode;
}

const Layout: FC<LayoutProps> = ({ children }: LayoutProps) => {
  const [mobileMenuOpened, setMobileMenuOpened] =
    React.useState<boolean>(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isAuthenticated = useSelector<RootState>(
    (state) => state.globalSlice.isAuthenticated,
  );

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleLogout = () => {
    delete axios.defaults.headers.common.Authorization;
    localStorage.removeItem("token");
    dispatch(SET_TOKEN(null));
    dispatch(IS_AUTHENTICATED(false));
    navigate("/");
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const { pathname } = useLocation();

  useEffect(() => {
    setMobileMenuOpened(false);
  }, [pathname]);

  return (
    <Container disableGutters maxWidth={false}>
      <AppBar position="sticky" sx={classes.appBar}>
        <Container maxWidth={false}>
          <Toolbar>
            <Link to="/">
              <img src="/static/images/logo.png" alt="logo caladre" />
            </Link>
            <Box>
              <IconButton
                size="large"
                onClick={() => setMobileMenuOpened(!mobileMenuOpened)}
                color="primary"
              >
                {mobileMenuOpened ? <CloseIcon /> : <MenuIcon />}
              </IconButton>
            </Box>
            <Box>
              <div>
                <Link to="/">
                  <Button
                    sx={{
                      ...(pathname === "/" &&
                        classes.selectedBtn),
                    }}
                  >
                    Je sais où je vais
                  </Button>
                </Link>
                <Link to="/je-cherche-un-voyage">
                  <Button
                    sx={{
                      ...(pathname === "/je-cherche-un-voyage" && classes.selectedBtn),
                    }}
                  >
                    Je cherche un voyage
                  </Button>
                </Link>
              </div>
              <ButtonGroup variant="text" aria-label="text button group">
                {!isAuthenticated ? (
                  <>
                    <Link to="/explorer-le-monde">
                      <Button>Explorer le monde</Button>
                    </Link>
                    <Link to="/auth">
                      <Button>Inscription</Button>
                    </Link>
                    <Link to="/auth">
                      <Button>Connexion</Button>
                    </Link>
                  </>
                ) : (
                  <>
                    {/* <Link to="/passeport">
                      <Button>Passeport</Button>
                    </Link> */}
                    <Link to="/explorer-le-monde">
                      <Button>Explorer le monde</Button>
                    </Link>
                    <Link to="/messagerie">
                      <Button>Messagerie</Button>
                    </Link>
                    <div>
                      <IconButton
                        size="large"
                        aria-label="account of current user"
                        aria-controls="menu-appbar"
                        aria-haspopup="true"
                        onClick={handleMenu}
                        color="inherit"
                      >
                        <AccountCircleOutlinedIcon color="primary" />
                      </IconButton>
                      <Menu
                        id="menu-appbar"
                        anchorEl={anchorEl}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                        keepMounted
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                      >
                        <MenuItem
                          sx={{ padding: "8px 24px !important" }}
                          onClick={() => {
                            navigate("/passeport");
                            handleClose();
                          }}
                        >
                          Passeport
                        </MenuItem>
                        <MenuItem
                          sx={{ padding: "8px 24px !important" }}
                          onClick={() => {
                            navigate("/parametres");
                            handleClose();
                          }}
                        >
                          Paramètres
                        </MenuItem>
                        <hr />
                        <MenuItem
                          sx={{ padding: "8px 24px !important" }}
                          onClick={() => {
                            handleClose();
                            handleLogout();
                          }}
                        >
                          Déconnexion
                        </MenuItem>
                      </Menu>
                    </div>
                  </>
                )}
              </ButtonGroup>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
      {children}
      {mobileMenuOpened && (
        <Fade in={mobileMenuOpened}>
          <Box sx={classes.mobileMenu}>
            <>
              <Link to="/">Je sais où je vais</Link>
              <Link to="/je-cherche-un-voyage">Je cherche un voyage</Link>
              {!isAuthenticated ? (<>
                <Link to="/auth">Inscription/Connexion</Link>
                <Link to="/explorer-le-monde">Explorer le monde</Link>
              </>
              ) : (
                <>
                  <Link to="/passeport">Passeport</Link>
                  <Link to="/explorer-le-monde">Explorer le monde</Link>
                  <Link to="/messagerie">Messagerie</Link>
                  <Link to="/parametres">Paramètres</Link>
                  <Link onClick={() => {
                    setMobileMenuOpened(false);
                    handleLogout();
                  }} to='/'>Déconnexion</Link>
                </>
              )}
            </>
          </Box>
        </Fade>
      )}
      <Container disableGutters maxWidth={false}>
        {pathname !== "/auth" && <Footer />}
      </Container>
    </Container>
  );
};

export default Layout;
